import { render, staticRenderFns } from "./TheRadarTopFiftyBadge.vue?vue&type=template&id=14d01c42&scoped=true&"
import script from "./TheRadarTopFiftyBadge.vue?vue&type=script&lang=js&"
export * from "./TheRadarTopFiftyBadge.vue?vue&type=script&lang=js&"
import style0 from "./TheRadarTopFiftyBadge.vue?vue&type=style&index=0&id=14d01c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d01c42",
  null
  
)

export default component.exports